<template #modal-overlay-template>
    <focus-trap :active="isActive" :initial-focus="initialFocus" :fallback-focus="initialFocus">
        <div class="modal-overlay" :class="{'open': isActive}" role="dialog">
            <button class="modal-overlay__close"
                    ref="closeButton"
                    @click="close"
                    @keydown.esc.prevent="close"
            >
                <span class="modal-overlay__close-icon">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.51322 5.99999L8.88685e-07 1.48679L1.48679 -4.59547e-07L6.00001 4.5132L10.5132 1.51938e-05L12 1.4868L7.4868 5.99999L12 10.5132L10.5132 12L6.00001 7.48678L1.48679 12L4.94128e-07 10.5132L4.51322 5.99999Z" fill="white"/>
                    </svg>
                </span>
                <span class="modal-overlay__close-text">Close</span>
            </button>
            <div class="modal-overlay__wrapper">
                <div class="modal-overlay__inner">
                    <div id="modal_dialog" class="mec-modal-dialog"></div>
                </div>
            </div>
        </div>
    </focus-trap>
</template>

<script>
import {mapState, mapActions } from 'pinia'
import modalStore from "../store/useModalStore";
import {FocusTrap} from "focus-trap-vue";

export default {
    name : 'modal-overlay',
    components: {FocusTrap},
    computed: {
        ...mapState(modalStore, ['isActive']),
    },
    methods: {
        ...mapActions(modalStore, ['close', 'open']),
        initialFocus() {
            return this.$refs.closeButton;
        },
    },
}
</script>
